
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface ErrorAlertProps {
  errorMessage: string | null;
}

const ErrorAlert = ({ errorMessage }: ErrorAlertProps) => {
  if (!errorMessage) return null;
  
  return (
    <Alert variant="destructive" className="mt-3">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>{errorMessage}</AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
